import {
  getCurrencySymbol,
  getCurrentCountryKey,
  getHomeCountryLabel,
  getLocaleTag,
  LOCALISATION_CONFIG,
} from "@/shared/config/localisation";

export type InvoiceLocalisationCode = "IN" | "AE" | "SA";

export type InvoiceLocalisation = {
  code: InvoiceLocalisationCode;
  brokerCountry: string;
  currencySymbol: string;
  numberLocale: string;
  taxLabel: string;
  taxRatePercent: number;
  hasStateSplit: boolean;
  taxIdLabel: string;
};

const DEFAULT_LOCALISATION_CODE: InvoiceLocalisationCode = "AE";

const CODE_BY_COUNTRY_KEY: Record<string, InvoiceLocalisationCode> = {
  IND: "IN",
  UAE: "AE",
  SAU: "SA",
};

const TAX_ID_LABEL_BY_CODE: Record<InvoiceLocalisationCode, string> = {
  IN: "GSTIN",
  AE: "TRN",
  SA: "VAT No.",
};

// Only India splits the domestic tax into CGST + SGST; VAT countries bill a single line.
const STATE_SPLIT_CODES: InvoiceLocalisationCode[] = ["IN"];

function resolveLocalisation(): InvoiceLocalisation {
  const code = CODE_BY_COUNTRY_KEY[getCurrentCountryKey()] || DEFAULT_LOCALISATION_CODE;

  return {
    code,
    brokerCountry: getHomeCountryLabel(),
    currencySymbol: getCurrencySymbol(),
    numberLocale: getLocaleTag(),
    taxLabel: LOCALISATION_CONFIG.tax.label,
    taxRatePercent: LOCALISATION_CONFIG.tax.percentage,
    hasStateSplit: STATE_SPLIT_CODES.includes(code),
    taxIdLabel: TAX_ID_LABEL_BY_CODE[code],
  };
}

export const INVOICE_LOCALISATION = resolveLocalisation();
